import React from 'react'
import GitHubCalendar from 'react-github-calendar';

const GitHubStats = () => {
  return (
    <>
     <GitHubCalendar style={{display:"flex", margin:"auto",flexDirection:"column",marginBottom:"40px",marginTop:"40px"}}username='utkarshqw'  />
    </>
  )
}

export default GitHubStats